import BaseService from "./baseService";

class DomService extends BaseService {
  constructor() {
    super('/dom-list')
  }

  async getScreenshot(data: any) {
    return this.post(`/get-screenshot`, data);
  }
}

export default new DomService();
